import React, { FC } from "react";

import classes from "./BaseContent.module.scss";

type BaseContentProps = {
  children: React.ReactNode;
};

const BaseContent: FC<BaseContentProps> = ({ children }) => {
  return <div className={classes.container}>{children}</div>;
};

export default BaseContent;
